import {
    StormOSLinkClose,
    StormOSLinkOpen,
    LinkTabOpen,
    setSaveFilePath,
    setSavePythonPath,
    setPythonModifly
} from '../reducers/menus.js';
import ScratchBlocks from 'scratch-blocks';
import {
    setCourse
} from '../reducers/mode.js';
import { setJSON } from '../reducers/downloadAlert.js';

if (window.require != undefined) {
    var ipcRenderer = window.require('electron').ipcRenderer;
}
let default_robot = 'E6'

const handleLinkRobot = function (type) {
    if (!ipcRenderer) {
        console.error('ipcRenderer不存在，不能连接')
        return
    }
    default_robot = type
    // 修改连接方式  E6:点击直接连接，不需要选择端口或者连接方式（连线或者蓝牙）
    //              C1:点击弹出窗口，选择连接方式（连线或者蓝牙，不需要选择端口）
    //              E3:没有连接成功判断，直接点击连接
    switch (type) {
        case 'E6':
            let data = {
                command: 'USB_CONNECTION',
                rcu: type
            }
            ipcRenderer.send('udp_cmd', data)
            localStorage.setItem('default_robot', type);
            break;
        case 'E3':
            window.__yourReactComp__.setState({
                link: true
            });
            break;
        case 'C1':
            localStorage.setItem('default_robot', type);
            document.getElementsByClassName('menu-bar_tip9Bg_1TNEL')[0].style.display = 'block';
            break;
        case 'M6':
            let dataM6 = {
                command: 'USB_CONNECTION',
                rcu: type
            }
            ipcRenderer.send('udp_cmd', dataM6)
            localStorage.setItem('default_robot', type);
            break;
        case 'C6':
            let dataC6 = {
                command: 'USB_CONNECTION',
                rcu: type
            }
            ipcRenderer.send('udp_cmd', dataC6)
            localStorage.setItem('default_robot', type);
            break;
        case 'E7':
            // window.store.dispatch(LinkTabOpen());
            localStorage.setItem('default_robot', type);
            break;

        case 'STORM_OS':
            window.store.dispatch(StormOSLinkOpen());
            break;
        case 'M5':
            let M5Data = {
                command: 'USB_CONNECTION',
                rcu: type
            }
            ipcRenderer.send('udp_cmd', M5Data)
            localStorage.setItem('default_robot', type);
            break;
        default:
            null
    }
}
const handleDisconnect = function (type) {
    window.__yourReactComp__.setState({
        hasUpdate: false, //不显示红点提示有新的固件更新 
    });
    if (!ipcRenderer) {
        console.error('ipcRenderer不存在，不能连接')
        return
    }
    switch (type) {
        case 'E6':
            ipcRenderer.send('udp_cmd', 'USB_DISCONNECTION')
            break;
        case 'E3':
            window.__yourReactComp__.setState({
                link: false
            });
            break;
        case 'C1':
            ipcRenderer.send('udp_cmd', 'USB_DISCONNECTION')
            ipcRenderer.send('udp_cmd', 'HID_DISCONNECTION')
            break;
        case 'M6':
            ipcRenderer.send('udp_cmd', 'USB_DISCONNECTION')
        case 'C6':
            ipcRenderer.send('udp_cmd', 'USB_DISCONNECTION')
            break;
        case 'E7':
            ipcRenderer.send('tcp_Close', false)
            break;
        case 'STORM_OS':
            ipcRenderer.send('DISCONNECT_STORM_OS')
            break;
        case 'M5':
            ipcRenderer.send('udp_cmd', 'USB_DISCONNECTION')
            break;
        default:
            null
    }
}
//连接 E7 控制器
const connectE7Robot = function () {
    if (!ipcRenderer) {
        console.error('ipcRenderer不存在，不能连接')
        return
    }
    default_robot = 'E7';
    ipcRenderer.send('tcp_Link')
}
const saveSelectE7Wifi = function (ip) {
    if (!ipcRenderer) {
        console.error('ipcRenderer不存在，不能连接')
        return
    }
    ipcRenderer.send('setE7Wifi', ip)
}
const disconnectE7 = function (isClearTime) {
    if (!ipcRenderer) {
        console.error('ipcRenderer不存在，不能连接')
        return
    }
    ipcRenderer.send('tcp_Close', isClearTime)
}


//连接 storm os 控制器
const connectStormOs = function (ip) {
    if (!ipcRenderer) {
        console.error('ipcRenderer不存在，不能连接')
        return
    }
    default_robot = 'STORM_OS'
    ipcRenderer.send('CONNECT_STORM_OS', ip)
}

ipcRenderer && ipcRenderer.on('link-reply', (event, arg) => {
    switch (arg) {
        case 'USB_CONNECTION_OK':
            // 连接成功
            window.__yourReactComp__.setState({
                link: true
            })
            document.getElementsByClassName('menu-bar_tip9Bg_1TNEL')[0].style.display = 'none';
            localStorage.setItem('default_robot', default_robot);
            break;
        case 'USB_CONNECTION_FAIL':
            // 连接失败
            // document.getElementsByClassName('menu-bar_tip5_3ajV4')[0].style.display = 'block';
            // setTimeout(function() {
            //     document.getElementsByClassName('menu-bar_tip5_3ajV4')[0].style.display = 'none';
            // }, 2000);
            window.__yourReactComp__.setState({
                isMenuClick: false
            });
            downloadAlert({
                show: true,
                type: 'Error',
                content: ScratchBlocks.Msg["gui.menuBar.jmd_not_open_downloadDebug"],
                animation: true,
                duration: 2000
            })
            break;
    }
})
ipcRenderer && ipcRenderer.on('hidlink-reply', (event, arg) => {
    if (arg == 'HID_CONNECTION_OK') {
        // 连接成功
        document.getElementsByClassName('menu-bar_tip9Bg_1TNEL')[0].style.display = 'none';
        window.__yourReactComp__.setState({
            link: true
        })
        localStorage.setItem('default_robot', default_robot);
    } else if (arg == 'HID_CONNECTION_FAIL') {
        // 连接失败
        // document.getElementsByClassName('menu-bar_tip5_3ajV4')[0].style.display = 'block';
        // setTimeout(function() {
        //     document.getElementsByClassName('menu-bar_tip5_3ajV4')[0].style.display = 'none';
        // }, 2000);
        window.__yourReactComp__.setState({
            isMenuClick: false
        });
        downloadAlert({
            show: true,
            type: 'Error',
            content: ScratchBlocks.Msg["gui.menuBar.jmd_not_open_downloadDebug"],
            animation: true,
            duration: 2000
        })
    }
})

ipcRenderer && ipcRenderer.on('disconnect-reply', (event, arg) => {
    window.__yourReactComp__.setState({
        isMenuClick: false
    });
    switch (arg) {
        case 'USB_DISCONNECTION_OK':
            // 断开连接成功
            window.__yourReactComp__.setState({
                link: false
            })
            break;
        case 'USB_DISCONNECTION_FAIL':
            // 断开连接失败
            break;
        case 'HID_DISCONNECTION_OK':
            window.__yourReactComp__.setState({
                link: false
            })
            break;
        case 'HID_DISCONNECTION_FAIL':
            break;
        case 'E7_DISCONNECTION_OK':
            window.__yourReactComp__.setState({
                link: false
            })
            break;
    }
})

ipcRenderer && ipcRenderer.on('E7Props_Datas', (event, arg) => {
    try {
        let jsonData = JSON.parse(arg.slice(12))
        let keys = Object.keys(jsonData)
        let motorProps = []
        let sensorProps = {}
        for (let item of keys) {
            if (/m\d/ig.test(item) && jsonData[item] == 1) {
                motorProps.push([item, item.slice(1, 2)])
            } else if (item.match(/p\d/ig)) {
                let key = jsonData[item]
                if (key != 'null') {
                    if (!sensorProps[key]) {
                        sensorProps[key] = []
                    }
                    sensorProps[key].push([item, item.slice(1, 2)])
                }
            }
        }
        window.motorProps = motorProps
        window.sensorProps = sensorProps
        console.log(motorProps, sensorProps)
        // window.workspace.refreshToolboxSelection_()
    } catch (err) {
        console.log(err)
    }
})

ipcRenderer && ipcRenderer.on('E7_JSON_CHANGE', (event, JSON) => {
    try {
        if(JSON.model && JSON.model == "setList"){
            let data = {}
            data[JSON.name] = JSON
            window.store.dispatch(setJSON(data))
        }
    }catch(err){
        console.log(err)
    }
})

ipcRenderer && ipcRenderer.on('saveFileStatus', (event, arg) => {
    downloadAlert({
        show: true,
        type: 'Info',
        content: window.store.getState().locales.messages["gui.menuBar.tip4"],
        animation: true,
        duration: 2000
    })
    window.store.dispatch(setSaveFilePath(arg))
})
ipcRenderer && ipcRenderer.on('savePythonStatus', (event, arg) => {

    const {
        path,
        isShowClose
    } = arg
    downloadAlert({
        show: true,
        type: 'Info',
        content: window.store.getState().locales.messages["gui.menuBar.tip4"],
        animation: true,
        duration: 2000
    })
    window.store.dispatch(setSavePythonPath(path))
    window.store.dispatch(setPythonModifly(false))
    isShowClose && ipcRenderer && ipcRenderer.send('main_close', window.store.getState().locales.messages);
})


ipcRenderer && ipcRenderer.on('closed', (event, arg) => {
    let python_modifly = window.store.getState().scratchGui.menus.python_modifly
    let projectTitle = window.store.getState().scratchGui.projectTitle.title
    let saveFilePath = window.store.getState().scratchGui.menus.save_python_path
    let monacodesValue = window.store.getState().scratchGui.monacodes.value
    if (python_modifly) {
        ScratchBlocks.customConfirm("提示", "是否保存", () => {
            let Obj = {
                projectTitle: projectTitle,
                pythonModifly: python_modifly,
                saveFilePath: saveFilePath,
                content: monacodesValue,
                isShowClose: true
            }
            ipcRenderer && ipcRenderer.send('save_python_File', Obj);
        }, () => {
            ipcRenderer && ipcRenderer.send('main_close', window.store.getState().locales.messages);
        })
    } else {
        ipcRenderer && ipcRenderer.send('main_close', window.store.getState().locales.messages);
    }
})
ipcRenderer && ipcRenderer.send('getSourse')

ipcRenderer && ipcRenderer.on('setCourse', (event, arg) => {
    if (typeof arg != "object") {
        console.log('数据类型错误')
        return
    }
    window.store.dispatch(setCourse(arg))
})

//监听electron主程序发过来的数据
ipcRenderer && ipcRenderer.on('downloadAlert', (event, arg) => {
    downloadAlert(arg)
})
export {
    handleLinkRobot,
    handleDisconnect,
    connectE7Robot,
    connectStormOs,
    saveSelectE7Wifi,
    disconnectE7
}
